export default "__VITE_ASSET__72806334__"